// DocumentIntelligenceStatusEnum
export const DocumentIntelligenceStatusEnumValues = [
  "PENDING",
  "SUCCESS",
  "ERROR",
] as const;
export type DocumentIntelligenceStatusEnumType =
  (typeof DocumentIntelligenceStatusEnumValues)[number];

// FileStatusEnum
export const FileStatusEnumValues = [
  "PENDING_UPLOAD",
  "UPLOAD_FAILED",
  "UPLOADED",
  "PROCESSING_FAILED",
  "POTENTIAL_MALWARE",
  "DUPLICATE",
] as const;
export type FileStatusEnumType = (typeof FileStatusEnumValues)[number];

// FileOriginEnum
export const FileOriginEnumValues = [
  "shared_department_import_upload",
  "chat_input_upload",
  "ai_profile_file_upload",
  "ai_profile_file_admin_upload",
  "ai_profile_thumbnail_upload",
  "sharepoint_import",
  "image_input_upload",
  "image_ai_generation",
  "translate_file_input_upload",
  "translation_output_file",
  "translation_glossary_export",
  "training_file_input_upload",
  "training_scenario_copy",
  "isearch_file_input_upload",
  "chat_dalle_tool_generation",
  "chat_research_word_export",
  "chat_research_excel_export",
  "chat_service_now_attachment",
  "chat_office_pdf_preview",
  "chat_azure_code_interpreter_output",
  "chat_aws_code_interpreter_output",
] as const;
export type FileOriginEnumType = (typeof FileOriginEnumValues)[number];

// Successfull file status
export const SUCCESSFUL_FILE_STATUSES: FileStatusEnumType[] = [
  "UPLOADED",
  "DUPLICATE",
];

// ImageScaleEnumValues
export const ImageScaleEnumValues = ["SMALL", "MEDIUM", "LARGE"] as const;
export type ImageScaleEnumType = (typeof ImageScaleEnumValues)[number];

// AppEnum
export const AppEnumValues = [
  "SHARED",
  "CHAT_AI",
  "IMAGE_AI",
  "TRANSLATE_AI",
  "TRAINING_AI",
  "ISEARCH",
  "VOICE_AI_POC",
  "RESEARCH_AI",
] as const;
export type AppEnumType = (typeof AppEnumValues)[number];

// EntityTypeEnum
export const EntityTypeEnumValues = [
  "PERSON",
  "ORGANIZATION",
  "LOCATION",
  "PRODUCT",
  "CONCEPT",
  "EVENT",
  "DOCUMENT",
  "SYSTEM",
  "METRIC",
  "OTHER",
] as const;
export type EntityTypeEnumType = (typeof EntityTypeEnumValues)[number];

// CommunityKindEnum — discriminates organic Leiden clusters from synthetic
// "tail residual" buckets that stitch together every cluster beyond
// MAX_COMMUNITIES_TO_SUMMARIZE so the UI has something to show for the
// long tail without paying an LLM call per cluster.
export const CommunityKindEnumValues = ["cluster", "residual"] as const;
export type CommunityKindEnumType = (typeof CommunityKindEnumValues)[number];
